if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if(this.cart.classList.contains('is-empty')){
          const formData = new FormData(this.form);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
          addProduct(formData.get("id"), 42018339323991);
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        console.log('formData>>>',formData,window.location.pathname);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        tC(1)
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            // await updateProduct(42018339323991);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
               window.addSlickSlider();
               window.cart_more_addSlickSlider();
              // window.addAddonProduct(); 
              
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            setTimeout(() => {
              
              window.addSlickSlider();
              window.cart_more_addSlickSlider();

              // const path = "/products/erotican-capsules-with-shilajit-to-boost-strength-and-stamina";
              // if (window.location.pathname === path) {
              //   const extraProductId = 42419062308951; // VARIANT ID
              //   if (extraProductId) {
              //     fetch('/cart/add.js', {
              //       method: 'POST',
              //       headers: { 'Content-Type': 'application/json' },
              //       body: JSON.stringify({
              //         id: extraProductId, // VARIANT ID
              //         quantity: 1,
              //         properties: { _free_gift: 'Yes' }
              //       })
              //     })
              //     .then(async (response) => {
              //       if (!response.ok) {
              //         throw new Error(response.statusText);
              //       }

              //       const result = await response.json();
              //       console.log('Free gifts added:', result);

              //       // if (window.refreshCart) window.refreshCart();
              //       $('.cart__checkout-button').attr('disabled', false);
              //     })
              //     .catch(err => {
              //       console.error('Failed to add free gifts:', err);
              //     });
              //   }
              // }
              const requiredHandle = 'erotican-capsules-with-shilajit-to-boost-strength-and-stamina-------------';
              const freeGiftVariantId = 42419062308951;
              fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                  const hasMainProduct = cart.items.some(
                    item => item.handle === requiredHandle
                  );

                  const freeGiftAlreadyAdded = cart.items.some(
                    item => item.variant_id === freeGiftVariantId
                  );

                  // Add free gift only if main product exists AND gift not already added
                  if (hasMainProduct && !freeGiftAlreadyAdded) {
                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        id: freeGiftVariantId,
                        quantity: 1,
                        properties: { _free_gift: 'Yes' }
                      })
                    });
                  }
                })
                .then(response => {
                  if (!response) return;
                  if (!response.ok) throw new Error(response.statusText);
                  return response.json();
                })
                .then(result => {
                  if (result) {
                    console.log('Free gift added:', result);
                    $('.cart__checkout-button').attr('disabled', false);
                    window.refreshCart();
                  }
                })
                .catch(err => {
                  console.error('Free gift logic failed:', err);
                  tC(0)
                });


            },1000);
            // window.addAddonProduct();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


window.addAddonProduct = async function () {   
   $('.cart__checkout-button').attr("disabled",true);
  try {
    const addonProducts = [];
    for (let i = 1; i <= 10; i++) {
      const pid = window[`addon_product${i > 1 ? '_' + i : ''}`];
      if (pid) addonProducts.push(pid);
    }

    const cart = await fetch('/cart.js').then(res => res.json());
    const has_freeproduct = cart.items.some(item => addonProducts.includes(item.id.toString()));

    console.log(has_freeproduct,'has_freeproduct>>>>');
     const items = addonProducts.map(pid => ({ id: pid, quantity: 1 }));
     if(!has_freeproduct){
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('Free gifts added:', result);
        if (window.refreshCart) window.refreshCart();
         $('.cart__checkout-button').attr("disabled",false);
      } else {
        console.error('Failed to add free gifts:', response.statusText);
      }
  }

  } catch (error) {
    console.error('Error adding free gifts:', error);
  }
};



//Only this product add this free product erotican-capsules-with-shilajit-to-boost-strength-and-stamina
// window.addFreeProduct = async function () {
  // $('.cart__checkout-button').attr("disabled",true);
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify({
  //       id: 42419062308951,
  //       quantity: 1,
  //       properties: {
  //         _free_gift: "Yes"
  //       }
  //     })
  //   })
  //   .then(res => res.json())
  //   .then(data => {
  //     console.log('Free product added', data);
  //     if (window.refreshCart) window.refreshCart();
  //     $('.cart__checkout-button').attr("disabled",false);
  //   })
  //   .catch(err => console.error(err));
  // }

  function addProduct(MainId, freeId){
    fetch('/cart/add.js', {
      method: "POST",
      headers:{
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        "items":[{
          "id": MainId,
          "quantity": 1
        },
        {
          "id": freeId,
          "quantity": 1
        }],
        sections: ["cart-drawer", 'cart-icon-bubble']
      })
    })
    .then(resp => resp.json())
    .then(result => {
      const parse = new DOMParser();
      const oldCartDrawer = document.querySelector('cart-drawer');
      const oldCartIconBubble = document.querySelector('#cart-icon-bubble');
      const newCartDrawer = parse.parseFromString(result.sections['cart-drawer'], 'text/html').querySelector('.shopify-section').querySelector('cart-drawer');
      const newCartIconBubble = parse.parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');

      if(newCartDrawer && oldCartDrawer) oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
      if(newCartIconBubble && oldCartIconBubble) oldCartIconBubble.innerHTML = newCartIconBubble.innerHTML;
      document.querySelector('cart-drawer').classList.toggle('is-empty',result.item_count == 0);
      document.querySelector('cart-drawer').classList.toggle('active', result.item_count != 0);
      document.querySelectorAll('.loading__spinner').forEach(item => item.classList.add('hidden'));
      document.querySelectorAll('[type="submit"]').forEach(item => item.classList.remove('loading'));

      // if(!document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('#cart-icon-bubble').click();
    })
  }